import Button from "../buttons/button";
import ReactQuill from "react-quill";
import TransParentButton from "../TransparentButton.js/TransParentButton";
import 'react-quill/dist/quill.snow.css';


const ConfirmModalWithQuill = ({
    isOpen,
    onClose,
    onConfirm,
    heading,
    subheading,
    cancelLabel = 'Cancel',
    confirmLabel = 'Confirm',
    isNote = false,
    noteValue = '',
    noteChange = null,
    noteError = ""
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/10 backdrop-blur-sm">
            <div className="bg-white p-6 rounded-[19px] shadow-lg text-center lg:w-[600px] w-11/12 mx-auto">
                <div className="flex items-center justify-center mb-4">
                    <img src="/warning.png" alt="" className="w-20 h-20" />
                </div>
                <p className="text-[17px] font-[600] text-black mb-2">{heading}</p>
                {subheading && (
                    <p className="text-[14px] text-gray-600 mb-4">{subheading}</p>
                )}
                {isNote && (
                    <div className="mb-4 text-left">
                        <ReactQuill
                            theme="snow"
                            value={noteValue}
                            onChange={noteChange}
                            className="bg-white"
                        />
                        {noteError && (
                            <p className="text-red-500 text-sm mt-2">{noteError}</p>
                        )}
                    </div>
                )}
                <div className="flex justify-center gap-4">
                    <TransParentButton onClick={onClose}>
                        {cancelLabel}
                    </TransParentButton>
                    <Button onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModalWithQuill;
